<br />
<div class="row">
  <div class="col-md-6">
    <fieldset>
      <b>Detalle de la venta</b>
      <hr />
    </fieldset>
  </div>
  <div class="col-md-6">
    <fieldset>
      <div class="input-group">
        <span class="input-group-text">Tipo de Venta</span>
        <select (ngModelChange)="actualizarPrecio($event)" [(ngModel)]="contado" class="form-control">
          <option *ngFor="let item of contados" [value]="item">
            {{ item }}
          </option>
        </select>
      </div>
    </fieldset>
  </div>

  <div class="col-md-3">
    <div class="form-group">
      <label for="">Cantidad ingresada</label>
      <input #cant type="number" min="1" max="99999" required="false" name="cantidad" id="cantidad"
        [(ngModel)]="cantidad" class="form-control" placeholder="" aria-describedby="helpId" />
      <small id="helpId" class="text-muted">Ingrese cantidad que ingresa</small>
    </div>
  </div>

  <div class="col-md-6">
    <app-cb-mercaderia-2 [require]="false" [dibujar]="mercaderia" (select)="itemSel($event)">
    </app-cb-mercaderia-2>
  </div>

  <div class="col-md-2">
    <div class="form-group">
      <label for="">&nbsp;</label>
      <button (click)="addRow()" type="button" name="agr" id="agr" class="btn btn-primary btn-md btn-block">
        <i class="fas fa-plus"></i>
      </button>
      <small id="helpId" class="text-muted">Agregar a la lista</small>
    </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-md-12">
    <div class="card shadow-sm">
      <div class="card-header bg-light">
        <strong>Detalle de la venta</strong>
      </div>
      <div class="card-body p-2">
        <div class="table-responsive" style="max-height: 300px; overflow-y: auto;">
          <table class="table table-striped table-bordered table-sm mb-0">
            <thead class="thead-dark">
              <tr class="d-flex text-center">
                <th class="col-2">Cantidad</th>
                <th class="col-2">Precio</th>
                <th class="col-6">Mercadería</th>
                <th class="col-2">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr class="d-flex align-items-center" *ngFor="let det of detalle">
                <td class="col-2 text-center">{{ det.cantidad }}</td>
                <td class="col-6">
                  [Stock: {{ det.mercaderia?.stock }}]
                  {{ det.mercaderia?.grupo?.nombre }} - {{ det.mercaderia?.nombre }}
                </td>
                <td class="col-2 text-right">{{ det.precio | currency : '$' }}</td>
                <td class="col-2 text-center">
                  <button (click)="remove(det)" type="button" class="btn btn-danger btn-sm" title="Eliminar producto">
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="detalle.length === 0">
                <td colspan="4" class="text-center text-muted">
                  No hay productos en la venta
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card-footer text-right">
        <strong>Total:</strong>
        {{ total | currency : '$' }}
      </div>
    </div>
  </div>
</div>